import React from "react";
import { Route, BrowserRouter as Router, Switch, Link } from "react-router-dom";
import Layout from "./Layout";
import { cardNames } from "./AllData";

class About extends React.Component {
  render() {
    return (
      <Layout>
        <div className="row mx-0">
          <div className="col-md-10 offset-md-1">
            <div className="row mx-0">
              {cardNames.map((el, index) => (
                <div className="col-md-3 col-sm-12" key={index}>
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title text-center">{el.title}</h4>
                      <div className="innerCard">
                        <Link className="btn buttonHome px-4" to={el.link}>
                          {el.button}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default About;
